var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9683_63547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5273 0C4.72869 0 0.0273438 4.70135 0.0273438 10.5C0.0273438 16.2993 4.72869 21 10.5273 21C16.3267 21 21.0273 16.3 21.0273 10.5C21.0273 4.70135 16.3266 0 10.5273 0ZM10.5273 19.0312C5.8155 19.0312 1.99613 15.2118 1.99613 10.5C1.99613 5.78815 5.8155 1.96878 10.5273 1.96878C15.2392 1.96878 19.0586 5.78815 19.0586 10.5C19.0586 15.2118 15.2392 19.0312 10.5273 19.0312ZM10.528 4.60489C9.77596 4.60489 9.20694 4.99735 9.20694 5.63127V11.4456C9.20694 12.0802 9.77589 12.4714 10.528 12.4714C11.2617 12.4714 11.8491 12.0638 11.8491 11.4456V5.63127C11.849 5.0124 11.2617 4.60489 10.528 4.60489ZM10.528 13.7813C9.80548 13.7813 9.21744 14.3693 9.21744 15.0924C9.21744 15.8143 9.80548 16.4023 10.528 16.4023C11.2505 16.4023 11.8379 15.8143 11.8379 15.0924C11.8378 14.3692 11.2505 13.7813 10.528 13.7813Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9683_63547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.0273438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationErrorIcon);
export default __webpack_public_path__ + "static/media/exclamationErrorIcon.4813798d0a034261b737613c830e0307.svg";
export { ForwardRef as ReactComponent };